import React from 'react';
import AuthPageReader from '../AuthPageReader.jsx';

const WaasSignInReader = (props) => <AuthPageReader {...props} domainType="WAAS" pageKey="signIn" />;

export default WaasSignInReader;
